"use strict";

angular.module('rmToken')
	.factory('Token', require('./token.js'));
